import { useCallback } from 'react';
import { CreateSurveyRequest } from '../../../types/Survey';
import {
  createSurvey,
  createSurveyDraft,
  updateSurvey,
  updateSurveyDraft,
} from '../../../api';
import { CreateSurveyDraftRequest } from '../../../types/SurveyDraft';

export interface UseActions {
  createTitle: (data: any) => Promise<void>;
}
export type ActionType =
  | 'createSurveyDraft'
  | 'updateDraft'
  | 'copyDraft'
  | 'createSurvey'
  | 'updateSurvey'
  | 'updateSurveyStatus'
  | 'copySurvey'
  | 'delete';

export default function useActions(props: {
  onSuccess: (action: ActionType) => void;
  onError: ({
    action,
    message,
    status,
  }: {
    action: ActionType;
    message?: string;
    status?: number;
  }) => void;
}) {
  const { onSuccess, onError } = props;
  const createDraftAction = useCallback(
    async (data: CreateSurveyDraftRequest) => {
      const result = await createSurveyDraft(data);
      if (!result.error) {
        return onSuccess('createSurveyDraft');
      }
      onError({ action: 'createSurveyDraft' });
    },
    [onSuccess, onError],
  );
  const updateDraftAction = useCallback(
    async (draftId: string, data: CreateSurveyDraftRequest) => {
      const result = await updateSurveyDraft(draftId, data);
      if (!result.error) {
        return onSuccess('updateDraft');
      }
      onError({ action: 'updateDraft' });
    },
    [onSuccess, onError],
  );

  const createSurveyAction = useCallback(
    async (data: CreateSurveyRequest) => {
      const result = await createSurvey(data);
      if (!result.error) {
        return onSuccess('createSurvey');
      }
      onError({ action: 'createSurvey', status: result.status });
    },
    [onSuccess, onError],
  );

  const updateSurveyAction = useCallback(
    async (surveyId: string, data: CreateSurveyRequest) => {
      const result = await updateSurvey(surveyId, data);
      if (!result.error) {
        return onSuccess('updateSurvey');
      }
      onError({ action: 'updateSurvey', status: result.status });
    },
    [onSuccess, onError],
  );

  return {
    createDraft: createDraftAction,
    updateDraft: updateDraftAction,
    createSurvey: createSurveyAction,
    updateSurvey: updateSurveyAction,
  };
}
